export default __webpack_public_path__ + "static/GT-Super-Display-Bold-1c61b4e3f72a89d3b18325237f148707.woff2";